import { render, staticRenderFns } from "./AccessKeys.vue?vue&type=template&id=66a7db51&scoped=true&"
import script from "./AccessKeys.vue?vue&type=script&lang=js&"
export * from "./AccessKeys.vue?vue&type=script&lang=js&"
import style0 from "./AccessKeys.vue?vue&type=style&index=0&lang=scss&"
import style1 from "./AccessKeys.vue?vue&type=style&index=1&id=66a7db51&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "66a7db51",
  null
  
)

export default component.exports